import { VehicleStatus } from "../logic/api";
import { options } from "../utility/options";

export default {
    text: {
        primary: "rgb(235, 48, 79)",
        secondary: "black",
        tooltip: "white",
        small: "rgb(184, 156, 160)"
    },
    bg: {
        primary: "#fff",
        secondary: "#FEFDFD",
        tooltip: "#333",
        nav: options.environment !== 'production' ? 'rgba(235, 48, 79, 0.2)' : '#FEFDFD',
    },
    active: {
        primary: "#EA334F",
        secondary: "#EEE",
    },
    states: {
        success: "green",
        danager: "red"
    },
    border: {
        primary: "#eee"
    },
    field: {
        border: {
            primary: "#CCC",
            secondary: "#EA334F",
        }
    },
    vehicleStatus: (vehicleStatus: VehicleStatus) => {
        if (vehicleStatus == VehicleStatus.NotCheckedIn) {
            return "red";
        } else if (vehicleStatus == VehicleStatus.PreCheckIn) {
            return "rgb(3, 102, 214)";
        } else if (vehicleStatus == VehicleStatus.CheckedIn) {
            return "green";
        } else if (vehicleStatus == VehicleStatus.CheckedOut) {
            return "orange";
        } else {
            return "black";
        }
    },
};
